import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button, CircularProgress } from "@mui/material";
import { Bar } from "react-chartjs-2";

export const AssociateProductManagerDashboard = () => {
  const tasks = [
    { id: 1, title: "Prepare market analysis report", progress: 70 },
    { id: 2, title: "Review product feature requests", progress: 40 },
    { id: 3, title: "Collaborate with design team on UI updates", progress: 90 },
  ];

  const chartData = {
    labels: tasks.map((task) => task.title),
    datasets: [
      {
        label: "Task Progress (%)",
        data: tasks.map((task) => task.progress),
        backgroundColor: ["#3f51b5", "#ff9800", "#4caf50"],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    },
  };

  return (
    <Box
      sx={{
        padding: 4,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Associate Product Manager Dashboard
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom align="center">
        Welcome to your dashboard! Track your tasks and progress here.
      </Typography>

      <Grid container spacing={4} sx={{ marginTop: 2 }}>
        {/* Task Progress Cards */}
        {tasks.map((task) => (
          <Grid item xs={12} sm={6} md={4} key={task.id}>
            <Card elevation={3} sx={{ height: "100%" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h6" gutterBottom>
                  {task.title}
                </Typography>
                <CircularProgress
                  variant="determinate"
                  value={task.progress}
                  sx={{ marginBottom: 2 }}
                />
                <Typography variant="body2" color="textSecondary">
                  Progress: {task.progress}%
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}

        {/* Task Progress Chart */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom align="center">
                Task Progress Overview
              </Typography>
              <Bar data={chartData} options={chartOptions} />
            </CardContent>
          </Card>
        </Grid>

        {/* Action Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              padding: 1.5,
              fontWeight: "bold",
              fontSize: "16px",
            }}
            onClick={() => alert("Feature coming soon!")}
          >
            View Detailed Reports
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AssociateProductManagerDashboard;